import { render, staticRenderFns } from "./LotsModal.vue?vue&type=template&id=56f49d74&"
import script from "./LotsModal.script.js?vue&type=script&lang=js&"
export * from "./LotsModal.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports